/*
  Maksimum sepet adedi (custom.max_qty_to_addtocart)

  - window.ftcMaxQty.showNotice: "Sepete Eklendi" pop-up'ında sınır uyarısını gösterir.
  - Tema dışından yapılan sepete eklemeleri (Insider arama sonuçları vb.) fetch üzerinden yakalar,
    sınır doluysa ürünü eklemez, aşılıyorsa adedi kalan kadar düşürür.
    product-form.static.js kendi kontrolünü yaptığı için "X-Max-Qty-Checked" header'ı ile gelir ve atlanır.
*/
(function () {
  if (window.ftcMaxQty) return;

  var DRAWER_SELECTOR = 'drawer-component[data-drawer="cart"]';
  var originalFetch = window.fetch.bind(window);
  var maxCache = {};
  var pending = null;

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function showNotice(max, added, open) {
    var drawer = getDrawer();
    var notice = drawer && drawer.querySelector('.max-qty-notice');

    if (!notice) {
      if (!added) alert('Bu ürün için sepete ekleme sınırına ulaştınız. En fazla ' + max + ' adet sipariş verebilirsiniz.');
      return;
    }

    var info = notice.querySelector('.max-qty-notice__info');
    if (info) info.textContent = (notice.dataset.infoText || '').replace('[max]', max);
    notice.hidden = false;

    var inner = notice.closest('.drawer__inner');
    if (inner) inner.classList.toggle('max-qty--not-added', !added);

    if (open) {
      drawer.classList.remove('is-empty');
      drawer.open();
    }
  }

  function getMax(handle) {
    if (!maxCache[handle]) {
      maxCache[handle] = originalFetch('/products/' + encodeURIComponent(handle) + '?view=max-qty', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : { max: 0 }; })
        .then(function (data) { return parseInt(data.max, 10) || 0; })
        .catch(function () { return 0; });
    }
    return maxCache[handle];
  }

  // data-max-qty taşımayan formlar (PrimeWidgets arama sonuçları vb.) için ürün handle'ını bul
  function findHandle(element, variantId, cart) {
    var cartItem = cart && cart.items.find(function (item) { return item.variant_id == variantId; });
    if (cartItem) return cartItem.handle;

    var handleHolder = element.closest('[product-handle]');
    if (handleHolder) return handleHolder.getAttribute('product-handle');

    var card = element.closest('.card-wrapper, .card, .grid__item, li');
    var link = card && card.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function resolveMax(element, variantId, cart) {
    var handle = findHandle(element, variantId, cart);
    return handle ? getMax(handle) : Promise.resolve(0);
  }

  function getCart() {
    return originalFetch('/cart.js', { credentials: 'same-origin' }).then(function (response) { return response.json(); });
  }

  function isChecked(init) {
    var headers = init && init.headers;
    if (!headers) return false;
    if (typeof headers.get === 'function') return !!headers.get('X-Max-Qty-Checked');
    return !!headers['X-Max-Qty-Checked'];
  }

  function blockedResponse(max) {
    return new Response(
      JSON.stringify({ status: 422, message: 'Cart Error', description: 'En fazla ' + max + ' adet sipariş verebilirsiniz.' }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var body = init && init.body;

    if (!/\/cart\/add(\.js)?(\?|$)/.test(url) || !(body instanceof FormData) || isChecked(init)) {
      return originalFetch(input, init);
    }

    var handleMatch = String(body.get('sections_url') || '').match(/\/products\/([^/?#]+)/);
    var variantId = body.get('id');
    if (!handleMatch || !variantId) return originalFetch(input, init);

    var requested = parseInt(body.get('quantity'), 10) || 1;

    return Promise.all([getMax(decodeURIComponent(handleMatch[1])), getCart()])
      .then(function (results) {
        var max = results[0];
        var cart = results[1];

        // Sınırsız ürün: sadece önceki uyarının kalıntısını temizlemek için işaretle
        pending = { max: 0 };
        if (!max) return null;

        var inCart = cart.items.reduce(function (sum, item) {
          return item.variant_id == variantId ? sum + item.quantity : sum;
        }, 0);
        var remaining = max - inCart;

        if (remaining <= 0) {
          pending = { max: max, added: false, itemCount: cart.item_count };
          return max;
        }

        if (requested > remaining) body.set('quantity', remaining);
        if (inCart + Math.min(requested, remaining) >= max) pending = { max: max, added: true };
        return null;
      })
      .catch(function () { return null; })
      .then(function (blockedMax) {
        return blockedMax ? blockedResponse(blockedMax) : originalFetch(input, init);
      });
  };

  // Insider drawer içeriğini /cart sayfasından kopyalayıp "active" sınıfıyla açıyor; açıldığı anda uyarıyı uygula
  function watchDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    new MutationObserver(function () {
      if (!pending || !drawer.classList.contains('active')) return;

      var current = pending;
      pending = null;

      if (!current.max) {
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('max-qty--not-added');
        return;
      }

      showNotice(current.max, current.added, false);

      // Ürün eklenmediği halde Insider sepet sayacını 1 artırıyor; gerçek değere geri al
      if (current.added === false) {
        var bubble = document.querySelector('.cart-count-bubble span');
        if (bubble) bubble.textContent = current.itemCount;
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  watchDrawer();

  // Ürün/sepet sayfasındaki kırmızı not, adet seçici sınıra ulaşınca görünür
  function updateNotes() {
    document.querySelectorAll('.max-qty-note[data-max-qty]').forEach(function (note) {
      var scope = note.closest('.cart-item') || note.closest('.product');
      var input = scope && scope.querySelector('.quantity__input');
      if (!input) return;
      note.hidden = !((parseInt(input.value, 10) || 0) >= parseInt(note.dataset.maxQty, 10));
    });
  }

  // Adet butonları (product-quantity-sync.js) stopPropagation yaptığı için capture fazında dinleniyor;
  // setTimeout ile değer güncellendikten sonra kontrol ediliyor
  ['click', 'change', 'input'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (event.target.closest && event.target.closest('quantity-input')) setTimeout(updateNotes);
    }, true);
  });

  window.ftcMaxQty = { showNotice: showNotice, resolveMax: resolveMax };
})();
